import React from 'react';
import styles from './index.module.scss';
import { EditReviewDto } from '@interfaces-clean/reviews.interface';
import { StudyMemberDto } from '@interfaces-clean/study-member.interface';
import { ReviewSubjectDto } from '@interfaces-clean/subject-monitoring/subject-review';
import ReviewPlanDetails from '@pages-clean/subject-monitoring/components/monitoring-toolkit/_shared/review-plan-details';
import ReviewProgressCardsList from '@pages-clean/subject-monitoring/components/monitoring-toolkit/_shared/review-progress-cards-list';
import ReviewSummaryCard from '@pages-clean/subject-monitoring/components/monitoring-toolkit/_shared/review-summary-card';

type Props = {
    review: EditReviewDto;
    smStudyMembers: StudyMemberDto[];
    reviewSubjects: ReviewSubjectDto[];
    studyRef: string;
};

const SMSelectedReviewSummaryTab = ({ review, smStudyMembers, reviewSubjects, studyRef }: Props) => {
    return (
        <div className={styles.grid}>
            <ReviewPlanDetails canEdit={false} review={review} smStudyMembers={smStudyMembers} studyRef={studyRef} />

            <ReviewProgressCardsList studyRef={studyRef} review={review} reviewSubjects={reviewSubjects} />

            {review.recordId != null && (
                <div className={styles.summarySection}>
                    <ReviewSummaryCard
                        canEdit={false}
                        studyRef={studyRef}
                        reviewRecordId={review.recordId}
                        currentSummary={review.reviewSummary}
                    />
                </div>
            )}
        </div>
    );
};

export default SMSelectedReviewSummaryTab;
